export default __webpack_public_path__ + "static/media/carbines.cb3380d7.svg";